<template>
  <div>
    <div class="profile-content">
        <v-row class="ma-0">
            <v-spacer></v-spacer>
            <v-btn                    
                large
                v-on:click="registerKennel"
                color="primary" dark
                width="175px"
                >+ New kennel</v-btn>
        </v-row>  
      <h1>My Kennels</h1>
      <div
        v-for="kennel in kennels"
        :key="kennel.kennelId"
        >
            <v-card class="user-profile-card">
            <v-card-title class="mt-5">
                <spacer/>
                    <p v-if="kennel.isHOF">
                        <span class="fa-layers award">
                            <font-awesome-icon size="5x" icon="award" />
                        </span>
                    </p>
                    <p v-if="kennel.isHOF">
                        <span>Hall of Fame</span><br/>
                        <span v-if="kennel.hofDate">{{$dateUtils.formatDate(kennel.hofDate)}}</span>
                    </p>
                    <p v-if="kennel.isHOFX">
                        <span class="fa-layers award">
                            <font-awesome-icon size="5x" icon="award" />
                        </span>
                    </p>
                    <p v-if="kennel.isHOFX">
                        <span>Hall of Fame Excellent</span><br/>
                        <span v-if="kennel.hofxDate">{{$dateUtils.formatDate(kennel.hofxDate)}}</span>
                    </p>
                    <p v-if="kennel.isSKE">
                        <span class="fa-layers award">
                            <font-awesome-icon size="5x" icon="award" />
                        </span>
                    </p>
                    <p v-if="kennel.isSKE">
                        <span>Stockdog Excellent</span><br/>
                        <span v-if="kennel.skeDate">{{$dateUtils.formatDate(kennel.skeDate)}}</span>
                    </p> 
              </row>
            </v-card-title>              
            <v-card-title>  
              <h1>{{ kennel.name }} (ID: {{ kennel.kennelId }})</h1>
            </v-card-title>
            <v-card-text>
                 <span v-if="kennel.startDate">
                    Start date: {{$dateUtils.formatDate(kennel.startDate)}},                     
                </span>
                <span v-if="kennel.expiryDate">
                    Expiration date: {{$dateUtils.formatDate(kennel.expiryDate)}}
                </span>
                <span v-else>
                    Permanent
                </span>
                <div class="mt-5">
                  <CoownersList :owners="kennel.coOwners" :ownershipType="kennelOwnershipType" />
                </div>    
                <v-row class="ma-0">
                        <v-spacer></v-spacer>
                        <v-btn    
                            v-if="kennel.canChangeOwners"                
                            large
                            v-on:click="changeKennelOwnersRequest(kennel)"
                            color="primary" dark
                            width="175px"
                            class="mr-5"
                        >Change owners</v-btn>
                </v-row>  
            </v-card-text>
          </v-card>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import personService from "@/services/portal/personService";
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: "MyKennels",
  components: {
    CoownersList,
  },
  data: function () {
    return {
      kennels: [],
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    kennelOwnershipType: function() {
      return OwnershipType.Kennel;
    },
  },
  methods: {
      changeKennelOwnersRequest: function(kennel: any) {
        this.$router.push({path: `/changekennelowners/${kennel.kennelId}`});
      },
      registerKennel: function() {
          this.$router.push({path: '/registration/kennel'});
      }
  },
  created: function () {
    if (this.userInfo) {
      personService
        .getKennelsByOwner(this.userInfo.personId)
        .then((res) => {
          this.kennels = res;
        })
        .catch(this.$handleError);
    }
  },
  watch: {
    userInfo: function (newVal: object) {
      personService
        .getKennelsByOwner(this.userInfo.personId)
        .then((res) => {
          this.kennels = res;
        })
        .catch(this.$handleError);
    }
  },
});
</script>
